// IMPORTANT: dayjs config must be imported first, before any Ant Design components
import './dayjs-config'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './i18n' // Initialize i18n before rendering
import './index.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
